import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Legacy Google OAuth callback handler.
 * The app now uses Clerk for authentication — #session_id= URLs from the
 * old OAuth flow are no longer issued. If we somehow land here, just clear
 * the hash and send the user to /auth so Clerk can take over.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    // Remove the hash fragment so it doesn't persist in history.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    // Send user to the Clerk-powered auth page.
    nav("/auth", { replace: true });
  }, [nav]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-10 h-10 text-[#14C8B0] animate-spin mb-3" strokeWidth={2.25}/>
      <p className="font-display font-bold text-[#0A0B0D]">Signing in…</p>
    </div>
  );
}
